/**
 * @generated SignedSource<<abbfc19c4b2ca7b111acf4ba2235fc3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActionType = "ASSESSMENT" | "CLICK" | "COMPONENT_ENTER" | "COMPONENT_EXIT" | "DIAGNOSTIC_ENDED_EARLY_BY_STUDENT" | "DIAGNOSTIC_END_EARLY_PROMPT_DISMISSED" | "DIAGNOSTIC_END_EARLY_PROMPT_SHOWN" | "DIAGNOSTIC_RESUMED" | "DIAGNOSTIC_STARTED" | "DIAGNOSTIC_SUBMITTED" | "DISMISS_FIRST_MONTH_TASKS_GUIDE" | "EXIT_SLIP" | "HIDE_DIAGNOSTIC_WIDGET" | "LESSON" | "LOGIN" | "LOGOUT" | "PRACTICE_PROBLEMS_RESET" | "PRACTICE_PROBLEMS_RESUMED" | "PRACTICE_PROBLEMS_STARTED" | "PREPARATION_FOR_DIAGNOSTIC_COMPLETED" | "REVIEW_CLASSES_COMPLETED" | "SET_CLASS_FOCUS_COMPLETED" | "SUSPICIOUS_ACTIVITY" | "SUSPICIOUS_ACTIVITY_BLUR" | "SUSPICIOUS_ACTIVITY_FOCUS" | "SUSPICIOUS_ACTIVITY_FULLSCREEN_EXIT" | "SUSPICIOUS_ACTIVITY_PASTE" | "UNDERSTAND_STUDENT_EXPERIENCE_COMPLETED" | "WELCOME_SCREEN_COMPLETED" | "WELCOME_SCREEN_SKIPPED" | "%future added value";
export type ClassDiagnosticStatusReportFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
};
export type DiagnosticsStatusByClassReportQuery$variables = {
  filter: ClassDiagnosticStatusReportFilterInput;
};
export type DiagnosticsStatusByClassReportQuery$data = {
  readonly classDiagnosticStatusReport: ReadonlyArray<{
    readonly diagnosticStatus: ActionType | null | undefined;
    readonly questionsAnswered: number | null | undefined;
    readonly student: {
      readonly diagnostics: ReadonlyArray<{
        readonly id: string;
        readonly retakeAssigned: boolean;
        readonly sessionStartedOn: any;
      } | null | undefined> | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
      readonly studentTargetGroups: ReadonlyArray<{
        readonly id: string;
        readonly isCurrent: boolean;
        readonly targetGroup: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly totalActiveTime: number | null | undefined;
  }>;
};
export type DiagnosticsStatusByClassReportQuery = {
  response: DiagnosticsStatusByClassReportQuery$data;
  variables: DiagnosticsStatusByClassReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "ClassDiagnosticStatusReport",
    "kind": "LinkedField",
    "name": "classDiagnosticStatusReport",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosticStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "questionsAnswered",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalActiveTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "student",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillDiagnosticNode",
            "kind": "LinkedField",
            "name": "diagnostics",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "retakeAssigned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionStartedOn",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentTargetGroupNode",
            "kind": "LinkedField",
            "name": "studentTargetGroups",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCurrent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetGroupNode",
                "kind": "LinkedField",
                "name": "targetGroup",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsStatusByClassReportQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticsStatusByClassReportQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "336b7c7788753b9b7707a2db1c551524",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsStatusByClassReportQuery",
    "operationKind": "query",
    "text": "query DiagnosticsStatusByClassReportQuery(\n  $filter: ClassDiagnosticStatusReportFilterInput!\n) {\n  classDiagnosticStatusReport(filter: $filter) {\n    diagnosticStatus\n    questionsAnswered\n    totalActiveTime\n    student {\n      id\n      lastName\n      firstName\n      publicUserId\n      diagnostics {\n        id\n        retakeAssigned\n        sessionStartedOn\n      }\n      studentTargetGroups {\n        id\n        isCurrent\n        targetGroup {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e07d313ddbffe4857098db9e0d499436";

export default node;
